/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Saturday, August 27th 2022, 5:25:43 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { SubscriptionPlan } from "./schemas";

export const getPriceFromInterval = ({
  subscriptionPlan,
  priceInterval,
}: {
  subscriptionPlan: SubscriptionPlan;
  priceInterval: SubscriptionPlan["prices"][number]["recurring"]["interval"];
}) => {
  return subscriptionPlan.prices?.find((price) => price.recurring?.interval === priceInterval);
};

export const getUnitAmount = ({
  price,
  withCurrency,
}: {
  price: SubscriptionPlan["prices"][number];
  withCurrency?: boolean;
}) => {
  const currencySymbol = withCurrency ? "$" : "";
  if (price.billing_scheme === "tiered") return `${currencySymbol}${price.tiers[0].unit_amount}`;
  return `${currencySymbol}${price.unit_amount}`;
};
